import Modal from "react-modal";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logoutUser } from "../../services/auth";

export default function LogoutModal({ modalIsOpen, Openchanger }) {
  const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
  const navigate = useNavigate();
  const customStylesDesktop = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "600px",
      height: "240px",
      border: "0px",
      overflowY: "hidden",
      position: "relative",
      borderRadius: "0.8rem",
      inset: "9px",
    },
  };

  const customStylesMobile = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "34rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(95vh - 1rem)",
      overflowY: "auto",
      border: "0px",
      position: "relative",
      borderRadius: "0.4rem",
      inset: "0px",
      margin: "0vh 0px 0px 0px",
    },
  };

  Modal.setAppElement("#root");

  function afterOpenModal() {}
  function closeModal() {
    Openchanger(false);
  }
  function handleLogout() {
    logoutUser().then((data) => {
      if (data.status === 200 || data.status === 201) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("refresh");
        navigate("/");
        toast.success("با موفقیت خارج شدید!");
      }
    });
  }
  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={isSmall ? customStylesMobile : customStylesDesktop}
        contentLabel="Example Modal"
        backdrop="static"
        id={"factor-modal"}
      >
        <div className={"container"} id={"factor-mbody"}>
          <div className="remove-cross" onClick={() => closeModal(false)}>
            &#10006;
          </div>
          <div className="logout-small-text">خروج از حساب کاربری</div>
          <div className="logout-red-note-text">
            از حساب کاربری‌ خارج می‌شوید؟
          </div>
        </div>
        <div className="logout-bottom-row-buttons ex-margin-items">
          <button
            className="form-input-button-custom not-active-login"
            onClick={() => {
              handleLogout();
            }}
          >
            خروج از حساب کاربری
          </button>
          <button
            className="form-input-button-custom"
            onClick={() => Openchanger(false)}
          >
            بازگشت به طلایی شو
          </button>
        </div>
      </Modal>
    </>
  );
}
